import _sfc_main from './effect-eq.vue2.js';
/* empty css              */
import _export_sfc from '../../../_virtual/_plugin-vue_export-helper.js';

const EffectEq = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-7baba32f"]]);

export { EffectEq as default };
//# sourceMappingURL=effect-eq.js.map
